import React from "react";
import { buildCruiseName } from "src/utils/cruise";
import * as styles from "./CruiseSegmentCard.module.scss";
import DateOnlyFormat from "components/DateOnlyFormat";
import clsx from "clsx";
import { CruiseSegment } from "src/templates/NewSpecialVoyage";
import { dequal } from "dequal/lite";
import CruiseDepartureArrivalDates from "components/cruises/CruiseDepartureArrivalDates";

interface CruiseSegmentCardProps {
  segment: CruiseSegment;
  active: boolean;
  onClick: (cruise: CruiseSegment) => void;
  backgroundColor: "destinationColor" | "titanium";
  title?: string;
}

const CruiseSegmentCard: React.FC<
  React.PropsWithChildren<CruiseSegmentCardProps>
> = ({ segment, onClick, active = false, backgroundColor, title }) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className={clsx({
        [styles.container]: true,
        [styles.containerTitanium]: backgroundColor == "titanium",
        [styles.active]: active
      })}
      onClick={() => onClick(segment)}
      onKeyDown={() => onClick(segment)}
    >
      <div className={styles.dates}>
        <CruiseDepartureArrivalDates
          departureDate={segment.data?.departureDate}
          arrivalDate={segment.data?.arrivalDate}
        />
      </div>
      <div className={styles.cruiseName}>
        {title && <div className={styles.title}>{title}</div>}
        {buildCruiseName(
          segment?.data?.departurePort?.data?.name?.localized,
          segment?.data?.arrivalPort?.data?.name?.localized
        )}
      </div>
    </div>
  );
};

export default React.memo(CruiseSegmentCard, dequal);
